import Vue from "vue";
import App from "@/views/Home/Index.vue";
import create from "@/router";
import VuePortalDialog from "@bilibili/growup-portal-dialog";
import VueObserveVisibility from "vue-observe-visibility";

import throttle from "@/directives/throttle";

import VueClipboard from "vue-clipboard2";
import { Swiper as SwiperClass, Navigation, Scrollbar, Pagination, Thumbs, EffectFlip, Autoplay } from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
SwiperClass.use([Navigation, Scrollbar, Pagination, Thumbs, EffectFlip, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
import "swiper/swiper-bundle.css";

import "@bilibili/growup-portal-dialog/dist/portal-dialog.css";
// import "@bilibili/share-panel/dist/share-panel.css";
import "@/styles/reset.scss";

const router = create();
Vue.use(VuePortalDialog, { blockMode: false, router });
Vue.use(VueObserveVisibility);
Vue.use(VueClipboard);

Vue.use(throttle);

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
